if(typeof BSS_B2B != undefined){
  setTimeout(() => {
    const elm = document.querySelector("nav.cart__drawer, .cart__template");
    if(elm){
      const observer = new MutationObserver((MutationList) => {
          for(const item of MutationList){
              if(item.target.className === 'item--loadbar'){
                 BSS_B2B.cart.fixer(JSON.parse($("#bss-b2b-store-data").html()), false, false)
              }
          }
      })
      observer.observe(elm, { attributes: true, childList: true, subtree: true })
    }
  }, 200)
}

setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
            if (item.target.className === 'collection__filters__wrapper filters--default-visible drawer--visible') {
                BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false, false);
            }
        }
    })
    observer.observe(document.body, {
        childList: true,
        subtree: true
    })
}, 300)

document.addEventListener("get_cart_subtotal_bss", e => {
   const save = document.querySelector("[data-left-to-spend]");
   const success_message = document.querySelector('.cart__message-success');
   const success_fail = document.querySelector('.cart__message-default');
    if(save) {
      if(e.detail.subtotal * 100 < 15000){
        save.innerText = BSS_B2B.formatMoney(15000 - e.detail.subtotal * 100);
        success_fail.style.display = 'block';
        success_message.style.display = 'none';
      } else {
         success_fail.style.display = 'none';
        success_message.style.display = 'block';
      }
    }
})